import Vehicles from './Vehicles';

export default Vehicles;
